module.exports = __webpack_public_path__ + "static/media/dash.9dc054de.svg";